import PostingPettyCashApi from '../__PostingPettyCashApi__';

export const generateNoPosting = async (date) => {
  return await PostingPettyCashApi.generateNumber({ tanggal: date }).then(
    (res) => res.data.data
  );
};
